import clsx from 'clsx';
import MaskedInput from 'components/elements/maskedInput';
import Maybe from 'components/elements/maybe';
import NumberText from 'components/elements/numberText';
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

interface Props extends Partial<HTMLElement> {
  itemValues: (number | null)[];
  lable: string;
  defaultValue?: string;
  name: string;
  postFix: string;
  disabled?: boolean;
  invisibleItems?: boolean;

  onChange?: (_value: string) => void;
  onFocusChange?: (_value: boolean) => void;
  onClickItem?: (_value: string) => void;
}

export type MinMaxItemValuesHandler = {
  focus: () => void;
  isFocued: boolean;
  value: string;
  toggleVisibility: () => void;
  setVisibity: (_value: boolean) => void;
};

const MinMaxItem: ForwardRefRenderFunction<MinMaxItemValuesHandler, Props> = (
  {
    itemValues: values,
    lable,
    defaultValue,
    name,
    postFix,
    disabled = false,
    invisibleItems: invisibleItem = false,

    onChange,
    onFocusChange,
    onClickItem,
  },
  ref
) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState('');
  const [itemsVisible, setItemsVisible] = useState(false);
  useEffect(() => {
    setInputValue(defaultValue || '');
  }, [defaultValue]);
  const inputOnChangeHandler = (e: any) => {
    setInputValue(e.target.value.toString());
    onChange && onChange(e.target.value);
  };

  useImperativeHandle(ref, () => ({
    focus() {
      inputRef.current && inputRef.current.focus();
    },
    toggleVisibility() {
      setItemsVisible((state) => !state);
    },
    setVisibity(value) {
      setItemsVisible(value);
    },
    get value() {
      return inputValue;
    },
    set value(value) {
      setInputValue(value);
      onChange && onChange(value);
    },
    get input() {
      return inputRef.current;
    },
    get isFocued() {
      return document.activeElement === inputRef.current;
    },
  }));

  return (
    <div className="flex-col felx">
      <MaskedInput
        disabled={disabled}
        mask={','}
        dir="ltr"
        name={name}
        type="text"
        value={inputValue}
        placeholder={lable}
        onChange={inputOnChangeHandler}
        className="w-full mb-3 text-sm rounded-md placeholder:text-center md:w-auto md:text-md focus:border-primary-500 focus:ring-primary-500 disabled:bg-grey-300"
        ref={inputRef}
        thousandSeparator
        autoComplete="off"
        onFocus={() => {
          onFocusChange && onFocusChange(true);
        }}
        onBlur={() => {
          onFocusChange && onFocusChange(false);
        }}
      />
      <p className="mb-1 text-xs font-bold text-primary-500">
        {!inputValue ? (
          lable
        ) : (
          <>
            <NumberText value={parseInt(inputValue)} />
            &nbsp;<span>{postFix}</span>
          </>
        )}
      </p>
      <Maybe condition={!invisibleItem}>
        <Maybe condition={itemsVisible && !disabled}>
          <ul className="flex flex-col">
            {values
              .filter((value) => !!value)
              .map((value) => (
                <li
                  className={clsx(
                    'mt-2 text-sm rounded-sm cursor-pointer first:m-0 hover:bg-grey-200',
                    {
                      'bg-grey-200': `${value}` === inputValue,
                    }
                  )}
                  onClick={() => {
                    setInputValue(value?.toString() || '');
                    onChange && onChange(value?.toString() || '');
                    onClickItem && onClickItem(value?.toString() || '');
                  }}
                  key={`min-${value}`}
                >
                  <NumberText>{value?.toString() || '0'}</NumberText>
                </li>
              ))}
          </ul>
        </Maybe>
      </Maybe>
    </div>
  );
};

export default forwardRef(MinMaxItem);
